import { render, staticRenderFns } from "./RemoveOrderDialog.vue?vue&type=template&id=74c276d0&"
import script from "./RemoveOrderDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports